<template>
    <div class="home">
        <div class="wrapper">
            <main :class="{hide: aniBox}" :style="{height: `${datas.length * (260 + 50) + 50}px`}">
                <article-item v-for="(item, index) in datas" :key="item.id" :data="item" :index="index" @click="articleClickHandle"></article-item>
            </main>
            <aside :class="{hide: aniBox}">
    
            </aside>
            <div class="box article-item" :class="{ani: aniBox}" :style="boxStyle" v-html="boxContent"></div>
        </div>
    </div>
</template>
<script>
import articleItem from '../components/v-article-item.vue';
import datas from '../data/article.json';
export default {
    components: {
        articleItem
    },
    name: 'home',
    props: {
        
    },
    data() {
        return {
            datas,
            aniBox: false,
            boxContent: '',
            boxStyle: {}
        }
    },
    methods: {
        articleClickHandle(data) {
            this.boxContent = data.content;
            this.boxStyle = {
                opacity: 1,
                transition: '0s',
                top: data.rect.top + document.body.scrollTop + 'px',
                left: data.rect.left + document.body.scrollLeft + 'px',
                width: data.rect.width + 'px'
            };
            setTimeout(() => {
                this.aniBox = true;
                this.boxStyle = {
                    opacity: 1,
                    transition: '0.6s cubic-bezier(0.645, 0.045, 0.355, 1)',
                    top: document.body.scrollTop + 'px',
                    left: 0,
                    width: window.innerWidth + 'px',
                    height: '50vh'
                }
            }, 10);
            setTimeout(() => {
                this.$router.push('/article/'+ data.data.id);
            }, 650);
        }
    }
}
</script>
<style lang="less">
@import '../../less/_var';
.home{
    .wrapper{
        display: flex;
        justify-content: space-between;
    }
    main{
        width: 1200px - 300 - 20;
        position: relative;
    }
    aside, main{
        transition: 0.5s;
        &.hide{
            opacity: 0;
        }
    }
    .box{
        position: fixed;
        z-index: 90;
        opacity: 0;
        pointer-events: none;
        height: 260px;
        will-change: top, left, opacity;
        &.ani{
            h2{
                top: 150px;
                font-size: 52px;
                left: 50%;
                padding-left: 0;
                transform: translate(-50%, 0);
                white-space: nowrap;
            }
        }
    }
}
</style>